<section class="playground">
  <h2 class="playground__heading">Schedule card</h2>
  <p class="playground__hint">
    <code>common-schedule-card</code> — Munily UI Kit
    <a
      href="https://www.figma.com/design/nZEfdJ8pN0ILY9cAkO3DSG/Munily-UI-Kit-%7C-Design-system?node-id=6512-33797"
      target="_blank"
      rel="noopener noreferrer"
      >Figma 6512:33797</a
    >.
  </p>

  <div class="playground__grid">
    <div class="playground__controls">
      <p class="playground__field">
        <code>ScheduleCardData</code>: <code>dayLabel</code> + <code>slots[]</code> con
        <code>fromLabel</code> / <code>toLabel</code> (anatomía Desde/Hasta del design system).
      </p>
    </div>

    <div class="playground__preview">
      <p class="playground__preview-title">Con dos franjas (variante <code>show_extra_card</code> en Figma)</p>
      <div class="playground__preview-box">
        <common-schedule-card [data]="sampleData"></common-schedule-card>
      </div>

      <p class="playground__preview-title" style="margin-top: 24px">Sin franjas</p>
      <div class="playground__preview-box">
        <common-schedule-card [data]="emptyData" emptyLabel="Sin horario definido"></common-schedule-card>
      </div>
    </div>
  </div>
</section>
